import React, { useState, useEffect } from 'react'

export default function(children) {
  const [steps, setSteps] = useState([])

  useEffect(() => {
    const _steps = []

    React.Children.map(children, (child) => {
      switch(child.type.displayName) {
        case 'TourSteps':
          React.Children.map(child.props.children, (stepChild) => {
            if(stepChild && stepChild.type.displayName === 'TourStep') {
              if(!stepChild.props.el()) return

              _steps.push({
                ...stepChild.props,
                tooltip: {
                  position: 'bottom',
                  alignment: 'left',
                  ...stepChild.props.tooltip,
                },
              })
            }
          })
          break
      }
    })

    setSteps(_steps)
  }, [])

  return steps
}